export const ZOOM = 'zoom';
export const CONFERENCE = 'conference';
export const IN_PERSON = 'in_person';
